import { Button } from '@/components/ui/button';
import LocalStorage from '@/lib/local-storage';
import { useContext, useEffect } from 'react';
import { GapSdkContext } from '../_provider/gap-sdk-provider';

export default function LogoutPage() {
  const { event } = useContext(GapSdkContext);

  useEffect(() => {
    LocalStorage.clearToken();
  }, []);

  return (
    <div className="flex size-full flex-col items-center justify-center">
      <div className="absolute left-1/2 top-1/2 mb-16 -translate-x-1/2 -translate-y-1/2 items-center justify-center text-center">
        <span className="bg-gradient-to-b from-foreground to-transparent bg-clip-text text-[10rem] font-extrabold leading-none text-transparent">
          Warning!
        </span>
        <h2 className="font-heading my-2 text-2xl font-bold">Unauthorized!</h2>
        <p>Your session has expired. Please log in again.</p>
        <div className="mt-8 flex justify-center gap-2">
          <Button onClick={() => event.onCloseApp()}>Back to App</Button>
        </div>
      </div>
    </div>
  );
}
